import axios from "axios";
import eventHub from "@/eventhub";

axios.interceptors.request.use(function (config) {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user ? user.token : "";
  config.baseURL = process.env.VUE_APP_API_URL;
  config.headers = {
    [process.env
      .VUE_APP_API_TOKEN_HEADER]: `${process.env.VUE_APP_API_TOKEN_PREFIX} ${token}`,
  };
  return config;
});

axios.interceptors.response.use(
  (config) => config,
  (error) => {
    if ((!error && !error.response) || error.code == "ERR_NETWORK") {
      eventHub.$emit("error_503");
    } else {
      if (
        error &&
        error.response &&
        error.response.status === 401 &&
        !error.response.config.url.includes("auth")
      ) {
        eventHub.$emit("error_401");
      }
    }
    return Promise.reject(error);
  }
);

export default {
  install(Vue) {
    Vue.prototype.$axios = axios;
  },
};
